var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition-group',{staticClass:"toast-container",attrs:{"tag":"div","name":"bounce"}},_vm._l((_vm.toasts),function(toast){return _c('ToastElement',_vm._b({key:toast.id,on:{"close":_vm.removeToast}},'ToastElement',toast,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }